import React, { Component } from "react";
import IDVerification from "./IDVerification";
import PersonalDetails from "./PersonalDetails";
import FileUploading from "./FileUploading";
import Confirmation from "./Confirmation";
import IBAN from "iban";
import PersonalInfo from "./Personalinfo";
import TermAndConditions from "./TermAndConditions";
import GetData from "../../../Api/GetData";
import { data } from "jquery";
import TellUsMore from "./TellUsMore";
import Compress from "react-image-file-resizer";
import analytics from '../../../firebase.config';

import { getAnalytics, logEvent } from "firebase/analytics";
var email = JSON.parse(localStorage?.getItem("user"))?.email

export default class SignUp extends Component {




  state = {
    step: 1,
    editFormStatus: localStorage.getItem("editFormStatus"),
    USResident: '',
    TaxPayer: '',
    AssoiciatedEmployee: "",
    EarnIncome: "",
    Type: "",
    firstName: JSON.parse(localStorage.getItem("user")).name ? JSON.parse(localStorage.getItem("user")).name : '',
    lastName: "",
    Gender: "",
    Salutations: "",
    MaritalStatus: "",
    Relation: "",
    RelativeName: "",
    otherProvince: '',
    otherCities: '',
    BirthDay: "",
    placeOfBirth: "",
    Citizenship: "",
    Resident: "",
    street: "",
    Apt: "",
    country: "",
    City: "",
    residentialCitiesList: [],
    residentiaProvinceList: [],
    Provinces: "",
    Zip: "",
    MailingAddress: true,
    PermanentProofOfAddressCheckbox: true,
    permanentProofOfAddressType: '',
    MailingProofOfAddressCheckbox: true,
    mailingProofOfAddressType: '',
    MailingProofRelationFile: '',
    MailingProofRelationFileNewUpload: '',
    MailingProofRelationFileName: '',
    MailingProofRelationFileSize: '',
    MailingAddressLine3: '',
    PermannentAddressLine3: '',
    Mailstreet: "",
    MailApt: "",
    mailCountry: "",
    MailCity: "",
    otherMailCity: "",
    mailCitiesList: [],
    mailProvinceList: [],
    MailProvinces: "",
    otherMailProvinces: "",
    email: email ? email : '',
    CellPhone: "1",
    Number: "",
    proofRelation: "",
    ProofRelationName: "",
    RelativeCNIC: "",
    ProofRelationFile: "",
    ProofRelationFileNewUpload: '',
    ProofRelationFileName: "",
    ProofRelationFileNameUC: "",
    sendProofRelationFile: "",
    ProofRelationFileSize: '',
    PermanentProofRelationFile: '',
    PermanentProofRelationFileNewUpload: '',
    PermanentProofRelationFileName: '',
    PermanentProofRelationFileSize: '',
    NomineeName: '',
    NomineeRelation: '',
    NomineeIDType: '',
    NomineeIDNumber: '',
    NomineeIssueDate: '',
    NomineeExpiryDate: '',
    NomineeLifeTimeExpiry: false,
    addnominee: false,



    IDType: "",
    CNIC: "",
    IssueDate: "",
    ExpiryDate: "",
    lifeTimeExpiry: false,
    IBAN: "",
    IBANError: true,
    showBankFeild: false,
    showOtherBankFeild: false,
    EmploymentStatus: "",
    // EmploymentStatus: "Employed",
    CompName: "",
    BussType: "",
    JobTitle: "",
    Department: "",
    OtherOccupation: '',
    EmployApt: "",
    EmployStreet: "",
    AnnualIncome: "",
    Zakat: "",
    ewalletprovider: "",
    otherewalletprovider: "",
    ewalletnumber: "",
    BasisOfRemittance: "",
    sourceofincome: "",
    UKN: "",
    MOTHER_MAIDEN_NAME: "",
    CNICFileFront: "",
    sendCNICFileFront: "",
    CNICFileFrontName: "",
    CNICFileFrontSize: '',
    CnicFrontUC: '',
    CnicBackUC: '',
    CNICFileBack: "",
    sendCNICFileBack: "",
    CNICFileBackName: "",
    CNICFileBackSize: '',
    CNICFileUnCompressesFrontName: '',
    CNICFileUnCompressedBackName: '',
    ProofRelationFileUnCompressed: '',
    SalerySlip: "",
    sendSalerySlip: "",
    sendSalerySlipName: '',
    AdditionalDocumentsName: '',
    documentTitle: '',
    AdditionalDocuments: '',
    SalerySlipSize: '',
    AdditionalDocumentsSize: '',
    AdditionalDocumentArray: [],
    BankStatement: "",
    sendBankStatement: "",
    Accepted: false,
    showValue: false,
    BankName: "",
    continues: false
  };


  componentDidMount() {
    this.getSaveDocuments()

    // Runs after the first render() lifecycle
    const response = GetData.getSaveAndExistData();
    response.then((value) => {
      console.log('value on component did mount is ====>>', value)
      // alert('1')
      if (value) {
        if (value?.data?.status !== "Not Found") {
          this.setState({
            editFormStatus: localStorage.getItem("editFormStatus"),
            USResident: value?.data?.RelationUS,
            TaxPayer: value?.data?.NonRelationUSPAK,
            AssoiciatedEmployee: value?.data?.RelationOrganization,
            EarnIncome: value?.data?.EarnIncome,
            // Type: value?.data.ACCOUNT_TYPE,
            Type: {
              value: value?.data.ACCOUNT_TYPE ? value?.data.ACCOUNT_TYPE : '',
              children: value?.data.ACCOUNT_TYPE_KEY ? value?.data?.ACCOUNT_TYPE_KEY : '',
            },
            /*
            Type: {
              value: 'NKA',
              children: 'Normal Account',
            },
            */
            firstName: value?.data?.firstName ? value?.data?.firstName : JSON.parse(localStorage.getItem("user")).name,
            lastName: value?.data?.lastName,
            Gender: value?.data?.GENDER,
            Salutations: {
              value: value?.data?.SALUTATION,
              children: value?.data?.SALUTATION_KEY
            },
            MaritalStatus: value?.data?.MARITAL_STATUS,
            Relation: {
              value: value?.data?.RELATIONSHIP1,
              children: value?.data?.RELATIONSHIP1_KEY
            },
            RelativeName: value?.data?.FATHER_HUSBAND_NAME,
            otherProvince: value?.data?.OTHERPROVINCE_STATE,
            otherCities: value?.data?.OTHERCITY_TOWN_VILLAGE,
            placeOfBirth: value?.data?.PLACE_OF_BIRTH,
            BirthDay: value?.data?.DATE_OF_BIRTH,
            Citizenship: {
              value: value?.data?.NATIONALITY,
              children: value?.data?.NATIONALITY_KEY
            },
            Resident: {
              value: value?.data?.residentialStatus,
              children: value?.data?.RESIDENT_KEY
            },
            street: value?.data?.multi?.PERMANENT_ADDRESS_2,
            Apt: value?.data?.multi?.PERMANENT_ADDRESS_1,
            country: {
              iso3: value?.data?.multi?.PERMANENT_COUNTRY ? value?.data?.multi?.PERMANENT_COUNTRY : value?.data?.PERMANENT_COUNTRY,
              label: value?.data?.COUNTRY1_KEY
            },
            PermannentAddressLine3: value?.data?.multi?.PERMANENT_ADDRESS_3,
            // City : value?.data?.PERMANENT_CITY_TOWN,
            City: {
              City_Code: value?.data?.PERMANENT_CITY_TOWN,
              label: value?.data?.PERMANENT_CITY_TOWN_VILLAGE_KEY
            },

            Provinces: {
              Province_code: value?.data?.PERMANENT_PROVINCE,
              label: value?.data?.PROVINCE_KEY
            },
            Zip: "",
            MailingAddress: value?.data?.Xd == "true" ? false : true,
            // MailingAddress: JSON.parse(value?.data?.Xd),
            Mailstreet: value?.data?.multi?.MAILING_ADDRESS_2,
            MailApt: value?.data?.multi?.MAILING_ADDRESS_1,
            mailCountry: {
              label: value?.data?.COUNTRY_KEY,
              iso3: value?.data?.COUNTRY
            },
            MailingAddressLine3: value?.data?.multi?.MAILING_ADDRESS_3,
            MailCity: {
              City_Code: value?.data?.CITY_TOWN_VILLAGE,
              label: value?.data?.CITY_TOWN_VILLAGE_KEY
            },
            PermanentProofOfAddressCheckbox: value?.data?.multi?.PROOF_OF_ADDRESS_TYPE ? false : true,

            permanentProofOfAddressType: {
              value: value?.data?.multi?.PROOF_OF_ADDRESS_TYPE,
              children: value?.data?.multi?.PROOF_OF_ADDRESS_TYPE
            },
            PermanentProofRelationFileName: value?.data?.multi?.PROOF_OF_ADDRESS,


            MailingProofOfAddressCheckbox: value?.data?.multi?.PROOF_OF_ADDRESS_MAILING ? false : true,
            mailingProofOfAddressType: {
              value: value?.data?.multi?.PROOF_OF_ADDRESS_MAILING_TYPE,
              children: value?.data?.multi?.PROOF_OF_ADDRESS_MAILING_TYPE
            },
            MailingProofRelationFileName: value?.data?.multi?.PROOF_OF_ADDRESS_MAILING,

            otherMailCity: value?.data.OTHERCITY_TOWN_VILLAGE,
            MailProvinces: {
              Province_code: value?.data?.PROVINCE_STATE,
              label: value?.data?.PROVINCE_STATE_KEY
            },
            otherMailProvinces: value?.data.OTHERPROVINCE_STATE,
            email: value?.data?.email,
            CellPhone: value?.data?.relationWithMobileNo,
            // Number: value.data.number,
            Number: (value.data.multi?.number?.substring(0, 2) == "03") ? ("92" + value.data.multi?.number?.substring(1, 11)) : value?.data?.multi?.number,

            // ,
            ProofRelationName: value?.data?.RELATIVE_NAME,

            RelativeCNIC: value?.data?.multi?.relativeCNIC,
            ProofRelationFile: "",
            ProofRelationFileName: value?.data?.multi?.RELATIVE_PROOF,
            ProofRelationFileNameUC: value?.data?.multi?.RELATIVE_PROOF_UC,
            sendProofRelationFile: "",
            proofRelation: {
              // value: value?.data?.RELATIONSHIP_KEY == 'Self' ? "" : value?.data?.RELATIONSHIP_KEY,
              // children: value?.data?.RELATIONSHIP,

              value: value?.data?.RELATIONSHIP == "01" ? "" : value?.data?.RELATIONSHIP,
              children: value?.data?.RELATIONSHIP_KEY == 'Self' ? "" : value?.data?.RELATIONSHIP_KEY,
            },
            NomineeName: value?.data?.NAME_NMN,
            NomineeIDType: value?.data?.IDENTIFICATION_NMN,
            NomineeRelation: {
              value: value?.data?.RELATIONSHIP_NMN,
              children: value?.data?.RELATIONSHIP_NMN_KEY,

            },
            NomineeIDNumber: value?.data?.multi?.CNIC_NMN,
            NomineeIssueDate: value?.data?.CNIC_ISSUE_DATE_NMN,
            NomineeExpiryDate: value?.data?.CNIC_EXPIRY_DATE_NMN,
            NomineeLifeTimeExpiry: value?.data?.CNIC_LIFETIME_NMN == 'true' ? true : false,
            addnominee: value?.data?.NAME_NMN ? true : false,
            // Income Detail Data 
            IDType: value?.data?.idType,
            CNIC: value?.data?.multi?.CNIC,
            IssueDate: value?.data?.issueDate,
            ExpiryDate: value?.data?.DATE_OF_EXPIRY,
            lifeTimeExpiry: value?.data?.LIFETIME_KEY == 'true' ? true : false,
            IBAN: value?.data?.IBAN,
            // IBAN: { value: value?.data?.IBAN },
            IBANError: false,
            showBankFeild: value?.data?.IBAN ? true : false,
            EmploymentStatus: value?.data?.EmploymentStatus,
            CompName: value?.data?.EMPLOYER_NAME,
            BussType: {
              value: value?.data?.OCCUPATION,
              children: value?.data?.OCCUPATION_KEY

            },
            JobTitle: value?.data?.JOB_TITLE,
            Department: value?.data?.Department,
            OtherOccupation: value?.data?.OTHER_OCCUPATION,
            EmployApt: "",
            EmployStreet: value?.data?.multi?.EMPLOYER_ADDRESS,
            AnnualIncome: {
              value: value?.data?.GROSS_ANNUAL_INCOME,
              children: value?.data?.GROSS_ANNUAL_INCOME_KEY
            },
            Zakat: {
              value: value?.data?.ZAKAT_STATUS,
              children: value?.data?.ZAKAT_STATUS_KEY
            },
            ewalletprovider: {
              value: value?.data?.E_WALLET_PROVIDER,
              children: value?.data?.E_WALLET_PROVIDER_KEY
            },
            otherewalletprovider: value?.data.OTHER_E_WALLET_PROVIDER,
            ewalletnumber: value?.data.E_WALLET_NUMBER,
            BasisOfRemittance: {
              value: (value?.data?.Remittance == '1' || value?.data?.Remittance == '3' || value?.data?.Remittance == '5') ? "1" : value?.data?.Remittance == '07' ? "7" : "2",
              children: value?.data?.RemittanceKey
            },
            sourceofincome: value?.data.SOURCE_OF_INCOME,
            UKN: value?.data?.UKN,
            MOTHER_MAIDEN_NAME: value?.data?.MOTHER_MAIDEN_NAME,
            BankName: value?.data?.BANK_NAME,

            // Documentations data
            CNICFileFront: "",
            sendCNICFileFront: "",
            CNICFileFrontName: value?.data?.multi?.CNIC_FRONT,
            CnicFrontUC: value?.data?.multi?.CNIC_FRONT_UC,
            CnicBackUC: value?.data?.multi?.CNIC_BACK_UC,
            CNICFileBack: "",
            sendCNICFileBack: "",
            CNICFileBackName: value?.data?.multi?.CNIC_BACK,

            SalerySlip: "",
            sendSalerySlip: "",
            sendSalerySlipName: value?.data?.multi?.ADD_PROOF,
            BankStatement: "",
            sendBankStatement: "",
            showValue: true

          })
        }

      }

    })
    this.getForm()

  }


  getSaveDocuments = () => {
    console.log('save data is called ========================================')
    const documnetResponse = GetData.getSaveDocumentData();
    documnetResponse.then((value) => {
      console.log('log respons eis getSaveDocumentData===========>>>', value?.data)


      this.setState({
        AdditionalDocumentArray: value?.data,
        AdditionalDocumentsName: 'yes'
        // documentTitle: '',
        // AdditionalDocuments: ''
      })

    })
  }
  getForm = () => {
    if (this.state.step === 1) {
      document?.getElementById("tellusMore").addEventListener("click", this.continueClicked);
    }
    else if (this.state.step === 2) {
      document?.getElementById("personalContinuee").addEventListener("click", this.continueClicked);
      document?.getElementById("personalContinuee2").addEventListener("click", this.continueClicked);
    }
    else if (this.state.step === 3) {
      document?.getElementById("IDVerification").addEventListener("click", this.continueClicked);
      document?.getElementById("IDVerification2").addEventListener("click", this.continueClicked);
    }
    else if (this.state.step === 4) {
      document?.getElementById("FileUploading").addEventListener("click", this.continueClicked);
      document?.getElementById("FileUploading2").addEventListener("click", this.continueClicked);
    }
    else if (this.state.step === 5) {
      document?.getElementById("TermsCondition").addEventListener("click", this.continueClicked);
    }
  }

  // for appling condition to check after atleast one time continue is clicked
  continueClicked = () => {
    this.setState({ continues: false }, () => { this.validation() })
  }


  validation = () => {
    Array.from(document.querySelectorAll('.Requirederror')).forEach(function (el) {
      el.classList.remove('Requirederror');
    });
    Array.from(document.querySelectorAll('.errorFeild')).forEach(function (el) {
      el.classList.remove('errorFeild');
    });



    var contactForm = document.getElementById('AOF-form');
    if (contactForm.checkValidity() == false) {
      if (this.state.continues) {
        // alert('5')


        document.getElementById("salutation")?.setAttribute("style", " display:block");
        document.getElementById("lastname")?.setAttribute("style", " display:block");
        document.getElementById("MaritalStatus")?.setAttribute("style", " display:block");
        document.getElementById("Relation")?.setAttribute("style", " display:block");
        document.getElementById("relativename")?.setAttribute("style", " display:block");
        document.getElementById("birthday")?.setAttribute("style", " display:block");
        document.getElementById("Citizenship")?.setAttribute("style", " display:block");
        document.getElementById("Resident")?.setAttribute("style", " display:block");
        document.getElementById("house")?.setAttribute("style", " display:block");
        document.getElementById("area")?.setAttribute("style", " display:block");
        //for adding border on invalid feilds
        var list = contactForm.querySelectorAll(':invalid');
        for (var item of list) {





          //for select options
          if (item.className == 'ReqFeild') {

            item.previousElementSibling.classList.add("Requirederror")
          }
          // for radios buttons
          else if (item.parentElement.parentElement.className.includes('combineButton')) {
            item.parentElement.parentElement.setAttribute("style", "border: 1px solid red !important;")
          }
          // for input feilds
          else {
            item.classList.add("errorFeild")
          }
        }

        //for removing borders on valid feilds

        var validList = contactForm.querySelectorAll(':valid');
        for (var item of validList) {
          // console.log('itemsibling', )
          if (item.className == 'ReqFeild') {

            item.previousElementSibling.classList.remove("Requirederror")
          }
          else if (item.parentElement.parentElement.className.includes('combineButton')) {
            item.parentElement.parentElement.style.removeProperty("border")
          }
          else {
            item.classList.remove("errorFeild")
          }
        }
      }
    }

    // for removing checks on moving toward new form

    if (contactForm.checkValidity() == true) {
      this.setState({ continues: false })
    }
  }


  prevStep = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 }, () => { this.getForm() });
  };

  // proceed to the next step
  nextStep = () => {
    const { step } = this.state;
    this.setState({ step: step + 1 }, () => { this.getForm() });
  };


  getBase64 = (file) => {
    var reader = new FileReader();
    reader?.readAsDataURL(file);
    reader.onload = function () {
      console.log(reader.result);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  addDocumentToArray = () => {
    let data = {
      id: Math.random(),
      name: this.state.documentTitle,
      file: this.state.AdditionalDocuments
    }
    let newArr = this.state?.AdditionalDocumentArray
    newArr?.push(data)
    this.setState({
      AdditionalDocumentArray: newArr,
      documentTitle: '',
      AdditionalDocuments: ''
    })
    // document.getElementById('AdditionalDocumentsUpload').value = "";
  }

  removeFile = (id) => {
    console.log({ id })



    const deletedocumentResponse = GetData.deleteDocuments(id);
    deletedocumentResponse.then((value) => {
      console.log('log respons eis deletedocumentResponse===========>>>', value)


      // this.setState({
      //   AdditionalDocumentArray: value?.data,
      //   AdditionalDocumentsName: 'yes'
      //   // documentTitle: '',
      //   // AdditionalDocuments: ''
      // })

    })

    const newArr = this.state.AdditionalDocumentArray.filter(item => item.id !== id);
    console.log({ newArr })
    this.setState({
      AdditionalDocumentArray: newArr
    })
  }


  // handle field change
  handleChange = (e) => {
    const { name, value, type, files, checked } = e.target;
    console.log(name, 'files ===========', value)

    if (type === "checkbox") {
      if (name === "MailingAddress" && checked) {

        this.setState({
          MailApt: this.state.Apt,
          Mailstreet: this.state.street,
          mailCountry: this.state.country,
          MailProvinces: this.state.Provinces,
          MailCity: this.state.City
        });
      }
      this.setState({
        [name]: checked,
      });
    }
    else if (type === "file" && files[0]) {
      console.log('files[0].type====================================', files[0].type)


      if (files[0].type == 'image/jpeg' || files[0].type == 'image/png') {



        // if (name !== 'SalerySlip') {
        if (files[0].type !== 'application/pdf') {

          if (name == 'AdditionalDocuments') {



            if (files[0].size / 1024 < 6145) {


              const file = files[0];





              var reader = new FileReader();

              reader.readAsDataURL(files[0]);
              console.log(files, 'files are ----->>>', name)
              this.setState({
                [name]: [files[0]],
                [name + 'Size']: files[0].size,
                ['send' + name]: reader.result
              }, () => { this.addDocumentToArray() });




            } else {
              alert("File size must be below 5 MB");
              this.handleDrctChange("AdditionalDocuments", '')

            }





          }



          else {


            if (files[0].size / 1024 < 5121) {


              const file = files[0];


              if (name == 'CNICFileFront') {
                logEvent(analytics, 'aof_docs_cnic_front_pic_attach');
                this.setState({
                  CNICFileUnCompressesFrontName: [file],

                });
              }
              if (name == 'CNICFileBack') {
                logEvent(analytics, 'aof_docs_cnic_back_pic_attach');
                this.setState({
                  CNICFileUnCompressedBackName: [file],

                });
              }

              if (name === "ProofRelationFile") {

                logEvent(analytics, 'aof_pers_info_phone_numb_proof_attach');
                this.setState({
                  ProofRelationFileUnCompressed: [file],

                });

              }


              else if (name === "SalerySlip") {

                logEvent(analytics, 'aof_docs_source_proof_attach');
              }


              if (files[0].size / 1024 < 450) {

                // if les than 500 then will not compress otherwise will compress
                var reader = new FileReader();

                reader.readAsDataURL(files[0]);
                console.log(files, 'files are ----->>>', name)
                this.setState({
                  [name]: [files[0]],
                  [name + 'Size']: files[0].size,
                  ['send' + name]: reader.result,
                  [name + 'NewUpload']: true
                });

                reader.onerror = function (error) {
                  console.log('Error: ', error);
                };
              } else {

                if (name == 'SalerySlip' || name == 'PermanentProofRelationFile' || name == 'MailingProofRelationFile') {
                  var reader = new FileReader();

                  reader.readAsDataURL(files[0]);
                  console.log(files, 'files are ----->>>', name)
                  this.setState({
                    [name]: [files[0]],
                    [name + 'Size']: files[0].size,
                    ['send' + name]: reader.result,
                    [name + 'NewUpload']: true
                  });

                  reader.onerror = function (error) {
                    console.log('Error: ', error);
                  };

                }



                else {

                  console.log('file <<<<<<<<<<<<<< ===========', file)

                  Compress.imageFileResizer(
                    file, // the file from input 
                    700,
                    700,

                    // "PNG", // compress format WEBP, JPEG, PNG
                    files[0]?.type?.substring(files[0]?.type?.indexOf('/') + 1), // compress format WEBP, JPEG, PNG
                    100,
                    0, // rotation
                    (uri) => {

                      console.log('uri size===========', uri.size / 1024)

                      if (uri.size / 1024 > 450) {

                        Compress.imageFileResizer(
                          uri, // the file from input 
                          500,
                          500,

                          "PNG", // compress format WEBP, JPEG, PNG
                          // files[0]?.type?.substring(files[0]?.type?.indexOf('/') + 1), // compress format WEBP, JPEG, PNG
                          100,
                          0, // rotation
                          (newFile) => {
                            console.log('log new file ==========================', newFile)

                            let newresponseUrl = [newFile]
                            console.log({ newresponseUrl, newFile });
                            this.setState({
                              [name + 'Size']: file.size,

                              [name]: newresponseUrl,
                              [name + 'NewUpload']: true

                            });

                          },
                          "file", // blob or base64 default base64

                        )
                      }
                      else {

                        let responseUrl = [uri]
                        console.log({ responseUrl, uri });



                        this.setState({
                          [name + 'Size']: file.size,

                          [name]: responseUrl,
                          [name + 'NewUpload']: true

                        });
                      }

                    },
                    "file", // blob or base64 default base64

                  );






                }



              }








            } else {
              alert("File size must be below 5 MB");
              if (name == 'CNICFileFront') {
                this.handleDrctChange("CNICFileFront", '')
              }
              if (name == 'CNICFileBack') {
                this.handleDrctChange("CNICFileBack", '')
              }
              if (name === "ProofRelationFile") {
                this.handleDrctChange("ProofRelationFile", '')
              }
              else if (name === "SalerySlip") {
                this.handleDrctChange("SalerySlip", '')

              }
            }
          }

        }
        else {
          alert("Only PDF file Allowed");
        }

      }
      else if (name == 'SalerySlip' || name == 'PermanentProofRelationFile' || name == 'MailingProofRelationFile') {

        console.log('in pdf section ==============')
        if (files[0].type == 'application/pdf') {
          console.log('in pdf section ==============')
          if (files[0].size / 1024 < 5121) {
            var reader = new FileReader();

            reader?.readAsDataURL(files[0]);
            this.setState({
              [name]: [files[0]],
              [name + 'Size']: files[0].size,
              ['send' + name]: reader.result
            });

            reader.onerror = function (error) {
              console.log('Error: ', error);
            };
          }
          else {
            alert("File size must be below 5 MB");
            this.handleDrctChange("SalerySlip", '')
          }
        }
        else {
          alert("Only PDF file Allowed");
        }



      }

      else if (name == 'AdditionalDocuments') {
        console.log('files[0].type  ???????????', files[0].type)

        if (files[0].type == 'application/pdf') {

          if (files[0].size / 1024 < 5121) {
            var reader = new FileReader();

            reader?.readAsDataURL(files[0]);
            this.setState({
              [name]: [files[0]],
              [name + 'Size']: files[0].size,
              ['send' + name]: reader.result
            }, () => { this.addDocumentToArray() });

            reader.onerror = function (error) {
              console.log('Error: ', error);
            };
          }
          else {
            alert("File size must be below 5 MB");
            this.handleDrctChange("AdditionalDocuments", '')
          }
        }

        else {
          alert("Only PDF,PNG,JPEG file Allowed");
        }



      }



      else {
        alert("Only image files can be uploaded (PNG and JPEG)");

      }





    }
    else if (
      name === "firstName" ||
      name === "lastName" ||
      name === "NomineeName" ||
      name === "RelativeName" ||
      name === "sourceofincome" ||
      name === "ProofRelationName"
      // name === "documentTitle"

    ) {
      if (e.target.value != ' ') {

        // this.setState({ [name]: value.replace(/[^a-zA-Z]\s/gi, "") });
        this.setState({ [name]: value.replace(/[\\\/\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-\,\?0-9/]/gi, "") });

      }
    } else if (
      // name === "street" ||
      name === "Apt" ||
      name === "street" ||
      name === "MailApt" ||
      name === "EmployStreet" ||
      name === "EmployApt" ||
      name === "Mailstreet" ||
      name === "sourceofincome" ||
      name === "documentTitle" ||
      name == "PermannentAddressLine3" ||
      name == "MailingAddressLine3"
    ) {
      if (e.target.value != ' ') {

        this.setState({ [name]: value.replace(/[\\\\!\@\$\%\^\&\)\(\+\=\<\>\{\}\[\]\:\;\?\'\"\|\~\`\_\-]/gi, "") });
        // this.setState({ [name]: value.replace(/[\\\/\!\@\$\%\^\&\)\(\+\=\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-\?0-9/]/gi, "") });

        // this.setState({ [name]: value.replace(/[\,\*\#\\\/.]/, "") });
        // this.setState({ [name]: value.replace(/[*,.#/]/, "") });
      }

      // this.setState({ [name]: value.replace(/[^a-zA-Z0-9\-#\s]/gi, "") });
    } else if (name === "CNIC" || name === "RelativeCNIC" || name === 'NomineeIDNumber') {
      if (e.target.value != ' ') {
        this.setState({ [name]: value.replace(/[^0-9]/gi, "") });
      }
    }


    else if (name === "email") {
      if (e.target.value != ' ') {
        this.setState({ [name]: value });
      }
    }
    else if (name === "IBAN") {
      let itValue = e.target.value.toUpperCase()
      this.setState({ [name]: itValue.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim(), IBANError: !IBAN.isValid(value.replace(/\s/g, '')) })
    }

    else if (name === "USResident" && value == 'Y') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_us_resident_citizen_press_yes');
    }

    else if (name === "USResident" && value == 'N') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_us_resident_citizen_press_no');
    }


    else if (name === "TaxPayer" && value == 'Y') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_of_any_other_country_press_yes');
    }
    else if (name === "TaxPayer" && value == 'N') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_of_any_other_country_press_no');
    }

    else if (name === "AssoiciatedEmployee" && value == 'Y') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_ever_been_in_org_press_yes');
    }
    else if (name === "AssoiciatedEmployee" && value == 'N') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_elig_ever_been_in_org_press_no');

    }
    else if (name === "MaritalStatus" && value == 'S') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_pers_info_mart_status_press_single');
    }
    else if (name === "MaritalStatus" && value == 'M') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_pers_info_mart_status_press_married');

    }
    else if (name === "CellPhone" && value == '1') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_pers_info_phone_owned_by_me');
    }
    else if (name === "CellPhone" && value == '2') {
      this.setState({ [name]: value });
      logEvent(analytics, 'aof_pers_info_phone_owned_by_other');

    }


    else if (name == 'CompName') {
      if (e.target.value != ' ') {
        this.setState({ [name]: value.replace(/[\'\/\\\?\(\)\:\;\"\%\$\#\&\@\^\*\,\.\-\!\`\~\_\+\{\}\[\]\<\>]/, "") });
      }
    }

    else if (name == 'Department') {
      if (e.target.value != ' ') {
        this.setState({ [name]: value.replace(/[\'\/\\\?\(\)\:\;\"\%\$\#\&\@\^\*\,\.\-\!\`\~\_\+\{\}\[\]\<\>]/, "") });
      }
    }
    else {
      if (e.target.value != ' ') {

        this.setState({ [name]: value.replace(/[\'\/\\\?\(\)\:\;\"\%\$\#\@\^\*\&\!\`\~\_\+\{\}\[\]\<\>]/, "") });
        //   this.setState({ [name]: value.replace(/[^0-9a-zA-Z]\s/gi, "") });
      }
    }
    this.validation()
  }


  handleDrctChange = (name, e) => {
    console.log(e, 'name in direct  is==================', name)

    if (name == 'PermanentProofRelationFileName' && e == '') {

      this.setState({ PermanentProofRelationFileNewUpload: '' }, () => this.validation());
    }
    if (name == 'MailingProofRelationFileName' && e == '') {

      this.setState({ MailingProofRelationFileNewUpload: '' }, () => this.validation());
    }
    if (name == 'ProofRelationFileName' && e == '') {

      this.setState({ ProofRelationFileNewUpload: '' }, () => this.validation());
    }
    if (name == 'Resident') {
      this.setState({
        IDType: "",

      });
    }
    this.setState({ [name]: e }, () => this.validation());
    if (name == 'Type') {
      this.setState({ AnnualIncome: "" }, () => this.validation());
    }
    else if (name === "ProofRelationFile") {

      logEvent(analytics, 'aof_pers_info_phone_numb_proof_remove');
    }

    else if (name === "CNICFileFront") {

      logEvent(analytics, 'aof_docs_cnic_front_pic_remove');
    }
    else if (name === "CNICFileBack") {

      logEvent(analytics, 'aof_docs_cnic_back_pic_remove');
    }
    else if (name === "SalerySlip") {

      logEvent(analytics, 'aof_docs_source_proof_remove');
    }
  };


  render() {
    const {
      step,
      editFormStatus,
      USResident,
      TaxPayer,
      AssoiciatedEmployee,
      EarnIncome,
      Type,
      firstName,
      lastName,
      Gender,
      Salutations,
      MaritalStatus,
      Relation,
      RelativeName,
      otherProvince,
      otherCities,
      placeOfBirth,
      BirthDay,
      Citizenship,
      Resident,
      street,
      Apt,
      country,
      City,
      residentialCitiesList,
      residentiaProvinceList,
      Provinces,
      MailingAddress,
      PermanentProofOfAddressCheckbox,
      permanentProofOfAddressType,
      MailingProofOfAddressCheckbox,
      mailingProofOfAddressType,
      MailingProofRelationFile,
      MailingProofRelationFileNewUpload,
      MailingProofRelationFileName,
      MailingProofRelationFileSize,
      MailingAddressLine3,
      PermannentAddressLine3,
      Mailstreet,
      MailApt,
      mailCountry,
      MailCity,
      mailCitiesList,
      mailProvinceList,
      otherMailCity,
      MailProvinces,
      otherMailProvinces,
      email,
      CellPhone,
      Number,
      proofRelation,
      ProofRelationName,
      RelativeCNIC,
      ProofRelationFile,
      ProofRelationFileNewUpload,
      ProofRelationFileName,
      ProofRelationFileNameUC,
      sendProofRelationFile,
      ProofRelationFileSize,
      PermanentProofRelationFile,
      PermanentProofRelationFileNewUpload,
      PermanentProofRelationFileName,
      PermanentProofRelationFileSize,
      NomineeName,
      NomineeRelation,
      NomineeIDType,
      NomineeIDNumber,
      NomineeIssueDate,
      NomineeExpiryDate,
      NomineeLifeTimeExpiry,
      addnominee,
      IDType,
      CNIC,
      IssueDate,
      ExpiryDate,
      lifeTimeExpiry,

      IBAN,
      IBANError,
      showBankFeild,
      showOtherBankFeild,
      EmploymentStatus,
      CompName,
      BussType,
      JobTitle,
      Department,
      OtherOccupation,
      EmployApt,
      EmployStreet,
      AnnualIncome,
      Zakat,
      ewalletprovider,
      otherewalletprovider,
      ewalletnumber,
      BasisOfRemittance,
      sourceofincome,
      UKN,
      MOTHER_MAIDEN_NAME,
      CNICFileFront,
      sendCNICFileFront,
      CNICFileFrontName,
      CNICFileFrontSize,
      CnicFrontUC,
      CnicBackUC,
      CNICFileBack,
      sendCNICFileBack,
      CNICFileBackName,
      CNICFileBackSize,
      CNICFileUnCompressesFrontName,
      CNICFileUnCompressedBackName,
      ProofRelationFileUnCompressed,
      SalerySlip,
      sendSalerySlip,
      sendSalerySlipName,
      AdditionalDocumentsName,
      AdditionalDocuments,
      SalerySlipSize,
      AdditionalDocumentsSize,
      documentTitle,
      AdditionalDocumentArray,
      BankStatement,
      sendBankStatement,
      Accepted,
      showValue,
      BankName,
      continues
    } = this.state;

    const values = {
      step,
      editFormStatus,
      USResident,
      TaxPayer,
      AssoiciatedEmployee,
      EarnIncome,
      Type,
      firstName,
      lastName,
      Gender,
      Salutations,
      MaritalStatus,
      Relation,
      RelativeName,
      otherProvince,
      otherCities,
      placeOfBirth,
      BirthDay,
      Citizenship,
      Resident,
      street,
      Apt,
      country,
      City,
      residentialCitiesList,
      residentiaProvinceList,
      Provinces,
      MailingAddress,
      PermanentProofOfAddressCheckbox,
      permanentProofOfAddressType,
      MailingProofOfAddressCheckbox,
      mailingProofOfAddressType,
      MailingProofRelationFileName,
      MailingProofRelationFileNewUpload,
      MailingProofRelationFileSize,
      MailingProofRelationFile,
      MailingAddressLine3,
      PermannentAddressLine3,
      Mailstreet,
      MailApt,
      mailCountry,
      MailCity,
      mailCitiesList,
      mailProvinceList,
      otherMailCity,
      MailProvinces,
      otherMailProvinces,
      email,
      CellPhone,
      Number,
      proofRelation,
      ProofRelationName,
      RelativeCNIC,
      ProofRelationFile,
      ProofRelationFileNewUpload,
      ProofRelationFileName,
      ProofRelationFileNameUC,
      sendProofRelationFile,
      ProofRelationFileSize,
      PermanentProofRelationFile,
      PermanentProofRelationFileNewUpload,
      PermanentProofRelationFileName,
      PermanentProofRelationFileSize,
      NomineeName,
      NomineeRelation,
      NomineeIDType,
      NomineeIDNumber,
      NomineeIssueDate,
      NomineeExpiryDate,
      NomineeLifeTimeExpiry,
      addnominee,
      IDType,
      CNIC,
      IssueDate,
      ExpiryDate,
      lifeTimeExpiry,

      IBAN,
      IBANError,
      showBankFeild,
      showOtherBankFeild,
      EmploymentStatus,
      CompName,
      BussType,
      JobTitle,
      Department,
      OtherOccupation,
      EmployApt,
      EmployStreet,
      AnnualIncome,
      Zakat,
      ewalletprovider,
      otherewalletprovider,
      ewalletnumber,
      BasisOfRemittance,
      sourceofincome,
      UKN,
      MOTHER_MAIDEN_NAME,
      CNICFileFront,
      sendCNICFileFront,
      CNICFileFrontName,
      CNICFileFrontSize,
      CnicFrontUC,
      CnicBackUC,
      CNICFileBack,
      sendCNICFileBack,
      CNICFileBackName,
      CNICFileBackSize,
      CNICFileUnCompressesFrontName,
      CNICFileUnCompressedBackName,
      ProofRelationFileUnCompressed,
      SalerySlip,
      sendSalerySlip,
      sendSalerySlipName,
      AdditionalDocumentsName,
      AdditionalDocuments,
      SalerySlipSize,
      AdditionalDocumentsSize,
      AdditionalDocumentArray,
      documentTitle,
      Accepted,
      showValue,
      BankName,
      continues
    };


    // <div className="feedback">Feedback</div>
    { console.log('121124', this.state) }
    switch (step) {

      case 1:
        return (
          <>


            {showValue == true ? (
              <>
                <TellUsMore
                  handleDrctChange={this.handleDrctChange}
                  prevStep={this.prevStep}
                  nextStep={this.nextStep}
                  handleChange={this.handleChange}
                  values={values}
                />
              </>
            ) : (
              <TellUsMore
                handleDrctChange={this.handleDrctChange}
                prevStep={this.prevStep}
                nextStep={this.nextStep}
                handleChange={this.handleChange}
                values={values}
              />
            )}


          </>
        );

      case 2:
        return (
          <>


            <PersonalDetails
              handleDrctChange={this.handleDrctChange}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />



          </>

        );

      case 3:
        return (
          <>
            <IDVerification
              handleDrctChange={this.handleDrctChange}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        );
      case 4:
        return (
          <>
            <FileUploading
              handleDrctChange={this.handleDrctChange}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
              removeFile={this.removeFile}
              getSaveDocuments={this.getSaveDocuments}
            />
          </>
        );
      case 5:
        return (
          <>
            <TermAndConditions
              handleDrctChange={this.handleDrctChange}
              prevStep={this.prevStep}
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              values={values}
            />
          </>
        );
      case 6:
        return (
          <Confirmation
            handleDrctChange={this.handleDrctChange}
            prevStep={this.prevStep}
            values={values}
          />
        );
      // never forget the default case, otherwise VS code would be mad!
      default:
      // do nothing
    }
  }
}
